<template>
  <div class="c-category-list-content">
    <div class="c-category-list-content__accordion-wrapper">
      <div
        class="c-category-list-content__accordion"
        v-for="(categoryLink, categoryIndex) in categoryLinks"
        :key="categoryIndex"
      >
        <div
          :class="[
            'c-category-list-content__accordion-header',
            { open: visibleCategories[categoryIndex] },
          ]"
          @click="toggleCategoryAccordion(categoryIndex)"
        >
          <a href="#">
            <img v-if="categoryLink.image" :src="categoryLink.image" />
            <span>{{ categoryLink.title }}</span>
          </a>
          <div class="c-category-list-content__open-icon-wrapper">
            <i class="c-category-list-content__open-icon"></i>
          </div>
        </div>
        <div
          :class="[
            'c-category-list-content__accordion-inner',
            { open: visibleCategories[categoryIndex] },
          ]"
        >
          <div class="c-category-list-content__child-accordion-wrapper">
            <div
              class="c-category-list-content__child-accordion"
              v-for="(link, index) in categoryLink.links"
              :key="index"
            >
              <div class="c-category-list-content__child-accordion-header">
                <template v-if="link.title.includes('すべて')">
                  <a :href="link.url">{{ link.title }}</a>
                </template>
                <template v-else>
                  <img :src="link.image" @error="hideImage($event)" />
                  <a :href="link.url">
                    {{ link.title }}
                  </a>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentsCategoryListContent',
  props: {
    categoryLinks: { type: Array, default: () => [] },
  },
  data() {
    return {
      visibleCategories: [],
    }
  },
  methods: {
    toggleCategoryAccordion(index) {
      this.visibleCategories[index] = !this.visibleCategories[index]
    },
    hideImage(event) {
      event.target.style.display = 'none'
    },
  },
}
</script>

<style lang="scss">
@use '~/scss/generic/mixins';

.c-category-list-content {
  display: block;

  &__accordion {
    max-width: 100%;
    margin: 0 auto;
  }

  &__accordion-header {
    background-color: #f4f4f4;
    border-bottom: 1px solid #efefef;
    color: #000000;
    font-size: 16px;
    padding: 20px 11%;
    text-align: left;
    position: relative;
    z-index: +1;
    cursor: pointer;
    transition-duration: 0.2s;
  }

  &__child-accordion-header {
    background: #ffffff;
    margin-left: 30px;
    font-size: 16px;
    padding: 15px 60px 15px 15px;
  }

  &__accordion-inner {
    padding: 0;
    box-sizing: border-box;

    display: block grid;
    transition: grid-template-rows 0.5s;
    grid-template-rows: 0fr;
  }

  &__accordion-inner.open {
    grid-template-rows: 1fr;
  }

  &__child-accordion-wrapper {
    overflow: hidden;
  }

  &__child-accordion-header {
    background: #ffffff;
    margin-left: 60px;
  }

  &__accordion a {
    text-decoration: none;
  }

  &__accordion img {
    margin: 0;
    margin-right: 6px;
    width: 28px;
  }

  &__child-accordion a {
    margin: 0px 14px;
  }

  &__child-accordion img {
    margin: 0;
    width: 32px;
  }

  &__accordion-header:hover,
  &__child-accordion-header:hover {
    opacity: 0.8;
  }

  &__open-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    right: 5%;
    width: 40px;
    height: 40px;
    margin-top: -20px;
    box-sizing: border-box;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    transform-origin: center center;
    transition-duration: 0.2s;
  }

  &__open-icon {
    display: block;
    width: 18px;
    height: 18px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    transform-origin: center center;
    transition-duration: 0.2s;
    position: relative;
  }

  &__accordion-header.open &__open-icon {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }

  &__open-icon:before,
  &__open-icon:after {
    display: flex;
    content: '';
    background-color: #000000;
    border-radius: 10px;
    width: 14px;
    height: 1px;
    position: absolute;
    top: 9px;
    left: 0;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    transform-origin: center center;
  }

  &__open-icon:before {
    width: 1px;
    height: 14px;
    top: 3px;
    left: 6px;
  }

  &__accordion-header.open &__open-icon:before {
    content: none;
  }

  &__accordion-header.open &__open-icon:after {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  @include mixins.screen-mobile {
    &__open-icon-wrapper {
      width: 30px;
      height: 30px;
      margin-top: -15px;
    }
  }
}
</style>
